export const readBrandInUrl = () => {
  if (
    window.location.href.indexOf('brand=fido') !== -1 ||
    window.location.hostname.includes('chat.fido.ca') ||
    window.location.href.indexOf('fido.ca') !== -1
  ) {
    return 'fido';
  } else if (
    window.location.href.indexOf('brand=shaw') !== -1 ||
    window.location.hostname.includes('chat.shaw.ca') ||
    window.location.href.indexOf('shaw.ca') !== -1
  ) {
    return 'shaw';
  }
  return 'rogers';
};
